export class EntraRestoreReportEntityRelationships {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "membershipsRestored",
            "baseName": "membershipsRestored",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "membershipsDropped",
            "baseName": "membershipsDropped",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "ownersRestored",
            "baseName": "ownersRestored",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "roleAssignmentsRestored",
            "baseName": "roleAssignmentsRestored",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "licensesRestored",
            "baseName": "licensesRestored",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EntraRestoreReportEntityRelationships.attributeTypeMap;
    }
    constructor() {
    }
}
